import React, { useState, useEffect, useRef,useMemo } from "react";
import { FileUploader } from "react-drag-drop-files";
import APIUrls from "../../services/APIUrls";
import CustomProgressBar from "./CustomProgressBar";
import $ from "jquery";
import axios from "axios";
import ReactTooltip from 'react-tooltip';
import Constants from "../../Constants";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { confirmAlert } from "react-confirm-alert";
import { handleError, putAxiosResponse } from "../../services/authApiRoutes/APImethods";
import { updateSourceFiles } from "../../redux/reducers/SourceFilesSlice";
import { updateAsyncUploadAssetPendingFiles, updateAsyncUploadAssetCompletedFiles , updateAsyncUploadAssetInProgressFiles, updateReadyForValidation, updateValidationErrors, updateCanSubmitTranslation } from "../../redux/reducers/AsyncAssetUploadSlice";
import { getFileExtension, getDateAfterFormat, checkFileSizeInGb, formatBytes, getIndesignVersionWarningType, FileTypes} from "../../services/Util";
import { postAxiosFormDataResponse,downloadFile,getAxiosResponse,deleteAxiosResponse } from "../../services/authApiRoutes/APImethods";
import { FileIcon, SuccessTick, UploadIcon } from "../../AppIcons";
import { ConditionalBlock } from "../../ConditionalBlock";
import CustomToolTips from "../../components/global/CustomToolTips";
import DateFormat from "../../pages/DateFormat";

export default function MultiFileDragUpload(props) {
  const projectId = props.projectId;

  const files = useRef([]);
  const projectContentType = useSelector((CreateProjectContentTypeSlice) => CreateProjectContentTypeSlice.content_type_for_project_creation).value;
  const customerBootstrapData = useSelector(reduxStore => reduxStore.customer_bootstrap_data).value;
  const dispatch = useDispatch();
  const [isZipFile, setZipFile] = useState([]);
  const [showError, setError] = useState(false);
  const [disableDelete, setDisableDelete] = useState(false);
  const [uiFeatures, setUiFeatures] = useState({});
  const [disableUpload,setDisableUpload] = useState(false);
  const [hasValidFiles,setValidFiles] = useState(true);
  const [documentFileIdForIntemediateFile, setDocumentFileIdForIntemediateFile] = useState(null);
  const currentFileIndex = useRef(null);
  const [assetIdForSRT, setAssetIdForSRT] = useState(null);
  const [extractZipToSeparateAsset, setExtractZipToSeparateAsset] = useState(false);
  const [multipleFilesSelected,setMultipleFilesSelected] = useState([])
  const [fileAdded,setFileAdded] = useState(true)
  const currentFileChunkIndex = useRef(null)
  const fileUploadProgress = useRef(0);
  const [assetVariant, setAssetVariant] = useState(null);
  const [sourceAssets, setSourceAssets] = useState([]);
  const [videoAssetName, setVideoAssetName] = useState(null);
  const [previousUploadedAssetVideoDetails, setPreviousUploadedAssetVideoDetails] = useState({});
  const [isPreviousUploadedAssetVideo, setIsPreviousUploadedAssetVideo] = useState(false);
  const [suppotedIndesignVersion, setSuppotedIndesignVersion] = useState();
  const [refresh, setRefresh] = useState(false);
  const [currentFileIndexInProgress, setCurrentFileIndexInProgress] = useState(-1);
  var pendingFilesMetadata = {};

  const projectCreationTooltipRef = useRef(null);
  const sourceFiles = useSelector((reduxStore) => reduxStore.source_files).value;
  const accountPermission = useSelector((updateCustomerBootstrapData) => updateCustomerBootstrapData.customer_bootstrap_data).value;
  const validationErrors = useSelector(reduxStore => reduxStore.asset_upload_background).value.validationErrors;
  const customerBootstrapDataRedux = useSelector((reduxStore) => reduxStore.customer_bootstrap_data).value;
  const pendingFiles = useSelector(reduxStore => reduxStore.asset_upload_background).value.pendingFiles;
  const projectData = useSelector(reduxStore => reduxStore.project_info).value;
  
  const [fileUploadPermission, setFileUploadPermission] = useState(false);
  const chunkSize = Constants.CHUNK_SIZE;
  const { t } = useTranslation();
  const translate = t;
  const handleChange = (e) => {
    handleDropChange(e);
  };
  const handleDropChange = (e) => {
    var file = Array.from(e);
    setValidFiles(true);
    if (files?.length > 0) {
      let filesCopy = [...files.current];
      file.forEach((newFile) => {
        filesCopy.push(newFile);
      });
      setMultipleFilesSelected(filesCopy)
      files.current = filesCopy;
    } else {
      files.current = file;
      setMultipleFilesSelected(file)
    }
  };

  const isInValidFileName = (fileName) =>{
    let inValidFileNamePattern = /^.*[’\\/:\\*\\\"<>—❞\\?\\\\]+.*$/;
    let isInvalidFileName = inValidFileNamePattern.test(fileName);
    if(fileName && isInvalidFileName && hasValidFiles){
        setValidFiles(false);
    }
    return isInvalidFileName;
  }
  function fileSelection(e) {
    dispatch(updateAsyncUploadAssetPendingFiles({}));
    setFileAdded(true)
    setValidFiles(true);
    if (e.target) {
      var multipleFiles = Array.from(e.target.files);
      files.current = multipleFiles;
      setMultipleFilesSelected(multipleFiles)
      const file = e.target.files[0];
      if (checkFileSizeInGb(file, accountPermission?.maxFileUploadSizeGb)) {
        setFileUploadPermission(true);
      } else {
        setFileUploadPermission(false);
      }
    }
  }

  useEffect(() => {
    let data = Object.assign({}, projectData);
    data.projectContentType = projectContentType;
    putAxiosResponse(APIUrls.PROJECT(projectId), data)
      .then(() => {
        return getAxiosResponse(APIUrls.PROJECT_UI_FEATURES(projectId));
      })
      .then((response) => {
        setUiFeatures(response.data.data);
      })
      .catch((err) => {
        console.error(err);
    });
    getAndPopulateAssets();
  }, []);

  const clearValue = (e) => {
    e.target.value = null;
  };
  useEffect(() => {
    const indexList = [];
    files.current.forEach((file, index) => {
      if (file && file !== "" && file.name.endsWith(".zip")) {
        indexList.push(index);
      }
    });
    setZipFile(indexList);
  }, [files.current]);
  function getAndPopulateAssets(resumeFileUpload) {
    fileUploadProgress.current = 0;
    setCurrentFileIndexInProgress(-1);
    Promise.all([getAxiosResponse(APIUrls.ASSET_LIST(projectId)), getAxiosResponse(APIUrls.GET_SOURCE_ASSETS(projectId))])
    .then(([assetResponse, sourceAssetResponse]) => {
        let assetList = assetResponse?.data?.data;
        let filteredAssets = [];
        assetList.forEach((asset) => {
          if (filteredAssets.filter((ass) => asset.id === ass.id).length === 0) {
            let matchList = assetList.filter((ass) => asset.id === ass.id);
            matchList = matchList.sort((a, b) => a.fileId > b.fileId ? 1 : -1);
            let selectedElement = JSON.parse(JSON.stringify(matchList[matchList.length - 1]));
            filteredAssets.push(selectedElement);
          }
        });

        let previousAsset = {};

            if (sourceAssetResponse.data.code === 200) {
              let sourceAssetsWithFilesVar = sourceAssetResponse.data.data;
              filteredAssets.forEach((sourceAsset) => {
                let fileExtensionOfAsset = getFileExtension(sourceAsset.filename);
                if (fileExtensionOfAsset === "mp4") {
                  sourceAsset.isVideoAsset = true;
                }
                if (previousAsset.assetId === sourceAsset.assetId && previousAsset.isVideoAsset && Constants.SUBTITLE_FILE_EXTENSIONS.includes(getFileExtension(sourceAsset.filename))) {
                  sourceAsset.isSubtitleFile = true;
                  setRefresh(true);
                }
                sourceAssetsWithFilesVar?.result?.forEach(
                  (sourceAssetWithFiles) => {
                    if (sourceAssetWithFiles?.files[sourceAsset?.assetVariant]?.documentFile?.id === sourceAsset.id) {
                      if (sourceAssetWithFiles?.files[sourceAsset?.assetVariant]?.asset?.assetType === "INDESIGN") {
                        setSuppotedIndesignVersion(customerBootstrapDataRedux.supportedIndesignVersion);
                        sourceAsset.assetType = sourceAssetWithFiles.files[sourceAsset.assetVariant].asset.assetType;
                        let indesignWarningCode = getIndesignVersionWarningType(sourceAsset.productVersion, customerBootstrapDataRedux.supportedIndesignVersion);
                        sourceAsset.indesignWarning =  indesignWarningCode;
                        setRefresh(true);
                      }
                    }
                    setTimeout(() => {
                      $(".uploading-file-list:last .download-icon").trigger(
                        "focus"
                      );
                    }, 500);
                  }
                );
                previousAsset = sourceAsset;
              });
              setSourceAssets(filteredAssets);
            }
        dispatch(updateSourceFiles(assetList));
        dispatch(updateAsyncUploadAssetCompletedFiles(assetList));
      })
      .catch((err) => {
        handleError(err);
      });
  }

  useEffect(() => {
    if(!refresh) {
      setSourceAssets(sourceFiles);
    }
  }, [sourceFiles]);

  const prepareSubtitleFileUpload = (sourceAsset) => {
    const intermediateAsset = sourceAssets.filter(
      (asset) =>
        asset.assetId === sourceAsset.assetId &&
        asset.assetVariant === "INTERMEDIATE"
    );
    let videoName = sourceAsset.filename;
    if (!videoName) {
      videoName = sourceAsset.name;
    }
    let assetId = sourceAsset.assetId;
    if (!assetId) {
      assetId = sourceAsset.id;
    }
    setAssetVariant("INTERMEDIATE");
    setVideoAssetName(videoName);
    setAssetIdForSRT(assetId);
    if (intermediateAsset?.length > 0) {
      setDocumentFileIdForIntemediateFile(intermediateAsset[0].id);
    }
  };
  function downloadAssetFile(assetId) {
    let filename = [];
    filename = sourceAssets.filter((sourceAsset) => {
      return sourceAsset.id === assetId;
    });
    if (filename?.length > 0) {
      downloadFile(
        APIUrls.DOWNLOAD_ASSET_FILE(projectId, assetId),
        filename[0].filename
      );
    }
  }
  function deleteAsset(asset) {
    deleteAxiosResponse(APIUrls.ASSET(projectId, asset.id)).then((res) => {
      setSourceAssets(sourceAssets.filter((sourceFile) => sourceFile.filename !== asset.filename));
      getAndPopulateAssets();
      var remaining = sourceFiles.filter((sourceFile) => sourceFile.filename !== asset.filename)
      dispatch(updateSourceFiles(remaining));
      const updatedValidationErrors = validationErrors.filter((validation) => validation.name !== asset.filename);
      const hasFailedValidation = updatedValidationErrors.some((validation) => validation.status === "fail" || validation.status ==="error");
      dispatch(updateValidationErrors(updatedValidationErrors));
      dispatch(updateCanSubmitTranslation(!hasFailedValidation && remaining.length !== 0));
      setDisableDelete(false);
      setTimeout(() => {
        const uploadFocus = $(".uploading-files-block > div").length;
        if (uploadFocus == "1") {
          $("#files").trigger("focus");
        }
      }, 1500);
    });
  }
  const confirmAssetDeletion = (sourceAsset) => {
    setDisableDelete(true);
    setTimeout(() => {
      $("#accept-delete-source-material").trigger("focus");
      $(".react-confirm-alert-overlay").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          if ($("button").hasClass("focusAdd")) {
            $(".focusAdd").trigger("focus");
            $(".focusAdd").removeClass("focusAdd");
          }
        }
      });
      setDisableDelete(false);
    }, 500);
    setTimeout(() => {
      $("#react-confirm-alert").attr({
        "aria-modal": "true",
        role: "dialog",
        "aria-labelledby": "deleteUploadfile",
      });
      $("h1").attr({
        id: "deleteUploadfile",
      });
    }, 200);
    confirmAlert({
      title: `${t("project_source_delete_title")}`,
      message: (
        <p>
          {`${t("project_source_delete_confirm_message")}`} <br />
          <strong>{sourceAsset.filename}</strong>
        </p>
      ),
      buttons: [
        {
          label: `${t("button_accept")}`,
          id: "accept-delete-source-material",
          onClick: () => { deleteAsset(sourceAsset)},
          onKeyDown: (e) => {
            if (e.key === Constants.TAB) {
              if (e.shiftKey === true) {
                e.preventDefault();
                $("#cancel-delete-source-material").trigger("focus");
              }
            }
          },
        },
        {
          label: `${t("button_cancel")}`,
          id: "cancel-delete-source-material",
          onClick: () => {
            setDisableDelete(false);
            setTimeout(() => {
              $(".focusAdd").trigger("focus");
              $(".delete-icon").removeClass("focusAdd");
            }, 200);
          },
          onKeyDown: (e) => {
            if (e.key === Constants.TAB) {
              if (e.shiftKey === false) {
                e.preventDefault();
                setDisableDelete(false);
                $("#accept-delete-source-material").trigger("focus");
              }
            }
          },
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
    });
  };

  function findDocumentId(pendingAssets, currentFileIndex) {
    if(pendingAssets) {
      for (let documentId in pendingAssets) {
        if (pendingAssets[documentId].fileId === currentFileIndex) {
            return documentId;
        }
      }
    }
    return null;
  }

  function readAndUploadCurrentChunk(pendingAssets) {
    setDisableUpload(true)
    const reader = new FileReader();
    const file = files.current[currentFileIndex.current];
    if (!file) {
      return;
    }
    let chunks = Math.ceil(file.size / chunkSize);
    if(chunks === 1) {
      setCurrentFileIndexInProgress(currentFileIndex.current)
    }
    let documentId = findDocumentId(pendingAssets, currentFileIndex.current);
    if (!documentId) {
      return;
    }
    const from = currentFileChunkIndex.current * chunkSize;
    const to = from + chunkSize;
    const blob = file.slice(from, to);
    reader.onload = (e) => uploadChunk(e, documentId, pendingAssets);
    reader.readAsDataURL(blob);
  }
  function uploadChunk(readerEvent, documentId, pendingAssets) {
    const file = files.current[currentFileIndex.current];
    const data = readerEvent.target.result;
    const params = new URLSearchParams();
    if (file?.extractZipContents) {
      params.set("extractZipToSeparateAsset", file?.extractZipContents);
    }
    params.set("name", file.name);
    params.set("size", file.size);
    params.set("docFileId", documentId);
    $(".progressReport").trigger("focus");
    if (assetVariant === "INTERMEDIATE") {
      params.set("assetVariant", assetVariant);
      params.set("assetId", assetIdForSRT);
    }
    params.set("currentFileChunkIndex", currentFileChunkIndex.current);
    params.set("totalChunks", Math.ceil(file.size / chunkSize));
    const headers = {
      "Content-Type": "application/octet-stream",
      "CSRF-Token": localStorage.getItem("csrfToken"),
    };
    const url =
      `${process.env.REACT_APP_BACKEND_SERVER}${APIUrls.ASSET_UPLOAD}?` +
      params.toString();
    axios.post(url, data, { headers }).then((response) => {
      if (response.data.success) {
        const file = files.current[currentFileIndex.current];
        const filesize = file?.size;
        const chunks = Math.ceil(filesize / chunkSize) - 1;
        // additional chunks === -1 condition is added to handle blank assets case
        const isLastChunk = currentFileChunkIndex.current === chunks || chunks === -1;

        if (isLastChunk) {
          fileUploadProgress.current = 100;
          const updatedPendingFiles = {
            ...pendingAssets,
            [documentId]: {
                ...pendingAssets[documentId],
                progress: 100
            }
        };
          dispatch(updateAsyncUploadAssetPendingFiles(updatedPendingFiles));
          file.finalFilename = response.data.finalFilename;
          if (getFileExtension(file.name) === "mp4") {
            setIsPreviousUploadedAssetVideo(true);
            if (response?.data?.results?.sourceAssetFile) {
              const sourceAssetFileArray =
                response?.data?.results?.sourceAssetFile;
              const sourceAssetFile =
                sourceAssetFileArray[sourceAssetFileArray?.length - 1];
              const videoAsset = sourceAssetFile?.asset;
              setPreviousUploadedAssetVideoDetails(videoAsset);
            }
          } else {
            setIsPreviousUploadedAssetVideo(false);
            setPreviousUploadedAssetVideoDetails({});
          }
          currentFileChunkIndex.current = null;
          if (files?.current.length > currentFileIndex.current + 1) {
            handleFileSelect(currentFileIndex.current + 1);

          } else {
            if (files.current?.length === currentFileIndex.current + 1) {
              setMultipleFilesSelected([])
              setDisableUpload(false)
              dispatch(updateAsyncUploadAssetPendingFiles({}))
              files.current = [];
              if(customerBootstrapData?.features?.ASSET_VALIDATION) {
                dispatch(updateReadyForValidation(true));
              }
              setTimeout(() => {
                currentFileIndex.current = null;
                getAndPopulateAssets("");
              }, 100);
            }
          }
          dispatch(updateValidationErrors([]));
          getAndPopulateAssets("");
          if (files.current.length && files.current.length > 0) {
            let selectedFiles = files?.current.map((file) => file.name.replace(" ", "_"));
            dispatch(updateSourceFiles([...sourceFiles, selectedFiles]));
          }
          dispatch(updateAsyncUploadAssetInProgressFiles([]));
          if (assetVariant === "INTERMEDIATE") {
            setAssetVariant(null);
            setAssetIdForSRT(null);
            setVideoAssetName(null);
          }
        }
        else {
           if(filesize=== 0 && !customerBootstrapData?.features?.ASSET_VALIDATION )
          {
           dispatch(updateAsyncUploadAssetPendingFiles({}))
          } 
          if(chunks !== -1) {
            currentFileChunkIndex.current = currentFileChunkIndex.current + 1;
            let progress = Math.round((currentFileChunkIndex.current / chunks) * 100);
            fileUploadProgress.current = progress;
            const updatedPendingFiles = {
                ...pendingAssets,
                [documentId]: {
                    ...pendingAssets[documentId],
                    progress: progress
                }
            };
            dispatch(updateAsyncUploadAssetPendingFiles(updatedPendingFiles));
            readAndUploadCurrentChunk(pendingAssets);
          } else {
            file.finalFilename = response.data.finalFilename || file.name;
            setMultipleFilesSelected([])
            setDisableUpload(false)
            files.current = [];
            currentFileChunkIndex.current = null;
            setTimeout(() => {
              currentFileIndex.current = null;
              getAndPopulateAssets("");
            }, 100);
            dispatch(updateValidationErrors([]));
            dispatch(updateAsyncUploadAssetInProgressFiles([]));
          }
        }
        $(".right-progressbar").each(function (index, el) {
          if ($(el).text().startsWith(file.name)) {
            $(this)
              .find(".out-side-flex")
              .find("div")
              .each(function (i, divElements) {
                if ($(this).attr("role") === "progressbar") {
                  $(this).attr("aria-label", `${fileUploadProgress.current}%`);
                  $(this)
                    .find("div")
                    .first()
                    .css("width", `${fileUploadProgress.current}%`);
                }
              });
            $(this)
              .find(".out-side-flex")
              .find("span")
              .first()
              .text(`${fileUploadProgress.current}%`);
          }
        });
      } else {
        files.current[currentFileIndex.current].error = response?.data?.detail ? response?.data?.detail : "Some error ocurred.";
        setValidFiles(false);
        setDisableUpload(false)
        currentFileIndex.current = null;
        currentFileChunkIndex.current = null;
        getAndPopulateAssets("");
        const updatedPendingFiles = {
          ...pendingAssets,
          [documentId]: {
              ...pendingAssets[documentId]
          }
        };
        dispatch(updateAsyncUploadAssetPendingFiles(updatedPendingFiles));
      }
    });
  }

  const getDocumentMetaData = async () => {
    let pendingAssets = {};
    let fileId = 0;
    if (files.current) {
      try {
        for (const file of files.current) {
          let documentUrl = APIUrls.DOCUMENT_EDIT_VARIANT;
          let postDataForDocumentEditVariant = {
            name: "SOURCE_ASSET",
            "project.id": projectId,
            docType: "SOURCE_ASSET",
          };
          if (documentFileIdForIntemediateFile) {
            postDataForDocumentEditVariant["document.id"] =
              documentFileIdForIntemediateFile;
            documentUrl = APIUrls.DOCUMENT_FILE_METADATA;
          }
  
          const res = await postAxiosFormDataResponse(documentUrl, postDataForDocumentEditVariant);
          if (res.data.documentFileId) {
            let documentId = res.data.documentFileId;
            pendingAssets = {
              ...pendingAssets,
              [documentId]: {
                file: file,
                fileId: fileId++
              }
            };
          }
        }
        dispatch(updateAsyncUploadAssetPendingFiles(pendingAssets));
        return pendingAssets;
      } catch (error) {
        handleError(error);
      }
    } else {
      return {};
    }
  }

  function handleFileSelect(fileIndex) {
    if (files.current.length > 0) {
      if (fileIndex === "") {
        dispatch(updateAsyncUploadAssetInProgressFiles([files.current]));
        getDocumentMetaData().then((pendingAssets) => {
          pendingFilesMetadata = pendingAssets;
          fileUploadProgress.current = 0;
          setCurrentFileIndexInProgress(-1);
          currentFileChunkIndex.current = 0;
          currentFileIndex.current = fileIndex !== "" ? fileIndex : 0;
          if (isPreviousUploadedAssetVideo.current && Constants.SUBTITLE_FILE_EXTENSIONS.includes( getFileExtension(files[currentFileIndex.current].name)) && assetVariant !== "INTERMEDIATE") {
            prepareSubtitleFileUpload(previousUploadedAssetVideoDetails);
          }else{
            readAndUploadCurrentChunk(pendingAssets);
          }
        }).catch((error) => {
          handleError(error);
        });
      } else {
        dispatch(updateAsyncUploadAssetInProgressFiles([files.current]));
        fileUploadProgress.current = 0;
        setCurrentFileIndexInProgress(-1);
        currentFileChunkIndex.current = 0;
        currentFileIndex.current = fileIndex !== "" ? fileIndex : 0;
        if (isPreviousUploadedAssetVideo.current && Constants.SUBTITLE_FILE_EXTENSIONS.includes( getFileExtension(files[currentFileIndex.current].name)) && assetVariant !== "INTERMEDIATE") {
          prepareSubtitleFileUpload(previousUploadedAssetVideoDetails);
        }else{
          readAndUploadCurrentChunk(pendingFilesMetadata);
        }
      }
    }
  }

  const getValidationStatus = (filename) => {
    let message = "";
    let status = "";
    let matchingValidationError = validationErrors.find((validationError) => validationError.name === filename);
    
    if(matchingValidationError) {
      message = matchingValidationError.error;
      status = matchingValidationError.status;
    }

    return {
        "message": message,
        "status": status
    };
  }

  const enableZipExtractionForFile = (multipleFiles, index) => {
    if(multipleFiles[index].extractZipContents === undefined) {
      multipleFiles[index].extractZipContents = true;
    } else {
      multipleFiles[index].extractZipContents = !extractZipToSeparateAsset
    }
  }

  return (
    <React.Fragment>
      <ConditionalBlock condition={uiFeatures.CHANGE_SOURCE_MATERIAL}>
        <div className="upload-file-block">
          <h3>{translate("project_listing.upload_local_files")} </h3>
          <div className="upload-file-container multifile-container">
            <div className="upload-icon">
              {UploadIcon}
            </div>
            <div className="upload-format">
              JPG, PNG, HTML , PDF
              <div className="more-format" tabIndex="0" role="tooltip" aria-label="more formats">
                <button tabIndex="-1">
                  {translate("project_listing.more_formats")}
                </button>
                <div className="more-format-popup">
                  <div className="triangle-with-shadow"></div>
                  <ul className="flex">
                    {FileTypes?.map((type, index) => {
                      if (FileTypes?.length > index + 1) {
                        return <li key={index}>{type}, </li>;
                      } else {
                        return <li key={index}>{type}</li>;
                      }
                    })}
                  </ul>
                </div>
              </div>{" "}
              ( {accountPermission?.maxFileUploadSizeGb} GB or less)
            </div>
            <FileUploader
              multiple={true}
              onSelect={(e) => handleChange(e)}
              onDrop={(e) => handleDropChange(e)}
              name="file"
              disabled={disableUpload}
              classes="drop_zone"
              hoverTitle="Drop here"
              children={
                <div className="upload-file-container mar-bot20">
                  <div className="file-drag">
                    {translate("project_listing.drag_drop_files")}{" "}
                    {files?.length > 0 ? "replace" : "Select"}
                  </div>
                </div>
              }
              label={"Upload or drop a file right here >>"}
            />
            {assetVariant === "INTERMEDIATE" && (
              <span>Upload subtitle file for {videoAssetName}</span>
            )}
            <div className="input-file ">
              <input type="file" id="files" multiple disabled={disableUpload} onChange={(e) => fileSelection(e)} onClick={(e) => clearValue(e)}/>
              <label className="file-button" htmlFor="files" createproject-tour="choose-file">
                {files.current?.length > 0
                  ? translate("project_listing.replace")
                  : translate("project_listing.choose_file")}
              </label>
            </div>
            <div className="gb-upload-files files">
              <div >
                {Object.keys(pendingFiles).length > 0 ?
                  Object.keys(pendingFiles).map((key, index) => {
                    fileUploadProgress.current = 0
                    if (pendingFiles[key].finalFilename) {
                      fileUploadProgress.current = 100;
                    } else {
                      const uploading = pendingFiles[key].fileId === currentFileIndex.current;
                      const chunks = Math.ceil(pendingFiles[key]?.file?.size / chunkSize);
                      if (uploading && chunks !== 0) {
                        fileUploadProgress.current = Math.round((currentFileChunkIndex.current / chunks) * 100);
                      } else {
                        fileUploadProgress.current = 0;
                      }
                      if(chunks === 1){
                        fileUploadProgress.current = 50;
                      }
                    }

                    return (
                      <div key={index} className={fileAdded ? 'added' : 'empty'}>
                        <div className="show-flex flex-center multiple-files">
                          <div className={Object.keys(pendingFiles)?.length > 0 ? "show-flex icon-block": "hide"}>
                            {FileIcon}
                          </div>
                          <div className="right-progressbar">
                            <label>
                              {pendingFiles[key]?.file?.name}{" "}
                              <ConditionalBlock condition={isInValidFileName(pendingFiles[key]?.file?.name)}>
                                  <div className="file-name-error">{"A filename can't contain any of the following characters \\ / : * ? \" < >  — ’"}</div>
                              </ConditionalBlock>
                              <ConditionalBlock condition={pendingFiles[key]?.file?.error?.length > 0}>
                                  <div className="file-name-error">{pendingFiles[key]?.file?.error}</div>
                              </ConditionalBlock>
                              {!fileUploadPermission ? Constants.BLANK : formatBytes(pendingFiles[key]?.file?.size)}{" "}
                            </label>
                            <div className="out-side-flex">
                              {pendingFiles[key]?.progress || currentFileIndexInProgress === pendingFiles[key]?.fileId? (
                                <CustomProgressBar
                                  completed={currentFileIndexInProgress === pendingFiles[key]?.fileId ? fileUploadProgress.current : pendingFiles[key]?.progress}
                                  labelLineHeight="1px"
                                  labelSize="14px"
                                  width="100%"
                                  labelClassName="progressBarLabel"
                                  borderRadius="30px"
                                  labelAlignment="outside"
                                  labelColor="rgba(0,0,0,0.87)"
                                  height="6px"
                                  className="campaign_progress"
                                  bgColor="#06B878"
                                  baseBgColor="#D1DEF0"
                                  ariaValuetext={currentFileIndexInProgress === pendingFiles[key]?.fileId ? fileUploadProgress.current : pendingFiles[key]?.progress}
                                  aria-label=""
                                  aria-valuenow={currentFileIndexInProgress === pendingFiles[key]?.fileId ? fileUploadProgress.current : pendingFiles[key]?.progress}
                                />
                              ) : ( "" )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }) 
                  : 
                  multipleFilesSelected.map((file, fileIndex) => {
                        return (
                          <div key={fileIndex} className={fileAdded ? 'added' : 'empty'}>
                            <div className="show-flex flex-center multiple-files">
                              <div className={multipleFilesSelected?.length > 0 ? "show-flex icon-block": "hide"}>
                                {FileIcon}
                              </div>
                              <div className="right-progressbar">
                                <label>
                                  {file?.name}{" "}
                                  <ConditionalBlock condition={isInValidFileName(file?.name)}>
                                      <div className="file-name-error">{"A filename can't contain any of the following characters \\ / : * ? \" < >  — ’"}</div>
                                  </ConditionalBlock>
                                  <ConditionalBlock condition={file?.error?.length > 0}>
                                      <div className="file-name-error">{file?.error}</div>
                                  </ConditionalBlock>
                                  {!fileUploadPermission ? Constants.BLANK : formatBytes(file.size)}{" "}
                                </label>
                                {!fileUploadPermission ? (
                                <div className={"radio-form-check" + (isZipFile.includes(fileIndex) ? " show mar-top15" : " hide")}>
                                  <input type="checkbox" className="form-check-input" name="radio" id={fileIndex} checked={file?.extractZipContents}
                                    onChange={() => enableZipExtractionForFile(multipleFilesSelected, fileIndex)} />
                                  <label className="form-check-label" htmlFor={fileIndex} >
                                    Extract ZIP file to individual assets
                                  </label>
                                </div>
                              ) : (
                                ""
                              )}
                              </div>
                            </div>
                          </div>
                        );
                      })
                }
              </div>
            </div>
            <div className={"error upload-error" + (showError === true ? " show" : " hide") } >
              Upload Failed: Our Apologies. One or more files in the zip is
              not supported by OPAL-Marketing.
            </div>
            {!fileUploadPermission ? (
              <button
                className={(files.current.length > 0 && !disableUpload && hasValidFiles) ? "btn" : "btn disabled hide"}
                disabled={(files.current.length > 0 && !disableUpload && hasValidFiles) ? false : true}
                id="valid-upload"
                onClick={() => handleFileSelect("")}
                createproject-tour="uploaded-files"
              >
                {customerBootstrapData?.features?.ASSET_VALIDATION ? translate("project_listing.validate_and_upload") : translate("button_upload")}
              </button>
            ) : (
              <span className="textDanger">
                File size exceeds {accountPermission.maxFileUploadSizeGb} GB.
              </span>
            )}
          </div>
        </div>
      </ConditionalBlock>
      <ConditionalBlock condition={!uiFeatures.CHANGE_SOURCE_MATERIAL}>
        <div>
          <h3 className="flex flex-nowrap">
            <span> <strong> {projectContentType} Source Files</strong></span>
            <CustomToolTips dataTip={translate("project_tool_tip")} toolTipRef={projectCreationTooltipRef} toolTipId="projectCreation" />
          </h3>
          <label> {translate("file_heading")}</label>
        </div>
      </ConditionalBlock>
  
    <div className="uploading-files-block uploading-success">
      <small className="hide">File Uploaded Successfully!</small>
      {sourceAssets?.map((sourceAsset, index) => {
        const validationStatus = getValidationStatus(sourceAsset.filename || sourceAsset.name);
        return (
          <div key={index}>
            <div className="uploading-file-list flex">
              <div className="left-file-desc flex-center">
                <div className="icon-block">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="33"
                    height="33"
                    viewBox="0 0 33 33"
                    fill="none"
                  >
                    <path
                      d="M12.375 17.875H20.625M12.375 23.375H16.5M5.5 5.5V27.5C5.5 28.2293 5.78973 28.9288 6.30546 29.4445C6.82118 29.9603 7.52065 30.25 8.25 30.25H24.75C25.4793 30.25 26.1788 29.9603 26.6945 29.4445C27.2103 28.9288 27.5 28.2293 27.5 27.5V11.4703C27.5 11.1039 27.4267 10.7412 27.2846 10.4036C27.1424 10.0659 26.9342 9.76008 26.6723 9.504L20.5673 3.53375C20.0535 3.0314 19.3635 2.75009 18.645 2.75H8.25C7.52065 2.75 6.82118 3.03973 6.30546 3.55546C5.78973 4.07118 5.5 4.77065 5.5 5.5V5.5Z"
                      stroke="#2C8D94"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M19.25 2.75V8.25C19.25 8.97935 19.5397 9.67882 20.0555 10.1945C20.5712 10.7103 21.2707 11 22 11H27.5"
                      stroke="#2C8D94"
                      strokeWidth="2"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <div className="file-text">
                  <span className="ext-name">
                    {sourceAsset.filename}&nbsp;
                    { !(sourceAsset.assetType === "INDESIGN" && sourceAsset.indesignWarning) && customerBootstrapDataRedux?.features?.ASSET_VALIDATION && validationErrors.length > 0 && validationStatus.status === "success" && SuccessTick}
                    <ConditionalBlock condition={sourceAsset.assetType === "INDESIGN" || sourceAsset?.isVideoAsset || sourceAsset?.isSubtitleFile}>
                      <div className="asset-badge">
                          {sourceAsset.assetType === "INDESIGN" && (
                            <div className="tooltip-container">
                              <span className="indesign-asset-badge" tabIndex={0} data-events={["focus"]} data-eventsoff={["blur"]}
                                data-padding="10px 10px 10px 10px" data-place="right" data-tip={sourceAsset.fileContents.split(',').join('<br \>')} data-for={"indesignUpload-" + index} aria-label="Tooltip">
                                Indesign {sourceAsset.productVersion}
                              </span>
                              <ReactTooltip className="tooltip extraClass" id={"indesignUpload-" + index} role="tooltip" html={true} />
                            </div>
                          )}
                          {sourceAsset?.isVideoAsset && (<span className="indesign-video">Video MP4</span>)}
                          {sourceAsset?.isSubtitleFile && (<span className="indesign-video-subtitle">Video Subtitles</span>)}
                        </div>
                    </ConditionalBlock>
                    {sourceAsset.assetType === "INDESIGN" && (
                      <div>
                        {sourceAsset.indesignWarning === 1 && (
                          <span className='alert-icon'>
                            <p className='warning'>This InDesign file's version is {sourceAsset.productVersion}, Preview will not be generated because we support up to version {suppotedIndesignVersion} only.</p>
                          </span>
                        )}
                        {sourceAsset.indesignWarning === 2 && (
                          <span className='alert-icon'>
                            <p className='warning'>This InDesign file's version is {sourceAsset.productVersion}, Preview may not be generated because it is an older version. We support up to version {suppotedIndesignVersion} only.</p>
                          </span>
                        )}
                      </div>
                    )}

                  </span>
                  <strong>
                    <span className="date-name">
                      <DateFormat date={sourceAsset.createdDate} />
                    </span>
                    <span className="file-size">
                      {sourceAsset.sizeInKilobytes / 1000} MB
                    </span>
                  </strong>
                  {customerBootstrapData?.features?.ASSET_VALIDATION && validationStatus.status === Constants.ERROR && <div className="error-alert failed">{validationStatus.message}</div>}
                  {customerBootstrapData?.features?.ASSET_VALIDATION && validationStatus.status === Constants.WARNING && <div className="warning-icon-text">{validationStatus.message}</div>}
                </div>
              </div>
              <div className="file-actions flex-center">
                <button
                  title={"Download - " + sourceAsset.filename}
                  aria-label={"Download - " + sourceAsset.filename}
                  className="download-icon"
                  onClick={() => downloadAssetFile(sourceAsset.id)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                  >
                    <path
                      d="M8.00087 17.6527L15.0742 10.5794C15.1834 10.4518 15.2405 10.2878 15.234 10.12C15.2275 9.9522 15.158 9.79304 15.0392 9.67431C14.9205 9.55558 14.7614 9.48602 14.5936 9.47954C14.4258 9.47306 14.2617 9.53013 14.1342 9.63935L8.66753 15.0993V1.33268C8.66753 1.15587 8.5973 0.986302 8.47227 0.861278C8.34725 0.736254 8.17768 0.666016 8.00087 0.666016C7.82406 0.666016 7.65449 0.736254 7.52946 0.861278C7.40444 0.986302 7.3342 1.15587 7.3342 1.33268V15.0993L1.8742 9.63935C1.81444 9.56956 1.74089 9.51288 1.65818 9.47287C1.57547 9.43285 1.48538 9.41036 1.39357 9.40682C1.30176 9.40327 1.2102 9.41874 1.12465 9.45226C1.0391 9.48577 0.961404 9.53661 0.896434 9.60158C0.831464 9.66655 0.780626 9.74425 0.747109 9.8298C0.713593 9.91535 0.698122 10.0069 0.701669 10.0987C0.705215 10.1905 0.727702 10.2806 0.767717 10.3633C0.807733 10.446 0.864413 10.5196 0.934201 10.5794L8.00087 17.6527Z"
                      fill="#6D7080"
                    ></path>
                  </svg>
                </button>
                {uiFeatures.CHANGE_SOURCE_MATERIAL &&
                  sourceAsset.assetVariant !== "INTERMEDIATE" && (
                    <button
                      title={"Delete - " + sourceAsset.filename}
                      aria-label={"Delete - " + sourceAsset.filename}
                      className="delete-icon"
                      onClick={() => confirmAssetDeletion(sourceAsset)}
                      disabled={disableDelete}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                      >
                        <path
                          d="M8.20039 3.80078H11.8004C11.8004 3.32339 11.6107 2.86555 11.2732 2.52799C10.9356 2.19042 10.4778 2.00078 10.0004 2.00078C9.523 2.00078 9.06516 2.19042 8.7276 2.52799C8.39003 2.86555 8.20039 3.32339 8.20039 3.80078ZM7.00039 3.80078C7.00039 3.00513 7.31646 2.24207 7.87907 1.67946C8.44168 1.11685 9.20474 0.800781 10.0004 0.800781C10.796 0.800781 11.5591 1.11685 12.1217 1.67946C12.6843 2.24207 13.0004 3.00513 13.0004 3.80078H19.0004C19.1595 3.80078 19.3121 3.864 19.4247 3.97652C19.5372 4.08904 19.6004 4.24165 19.6004 4.40078C19.6004 4.55991 19.5372 4.71252 19.4247 4.82505C19.3121 4.93757 19.1595 5.00078 19.0004 5.00078H17.7356L16.3028 17.4136C16.2015 18.291 15.7812 19.1006 15.1218 19.6883C14.4625 20.2759 13.61 20.6007 12.7268 20.6008H7.27399C6.39074 20.6007 5.53833 20.2759 4.87895 19.6883C4.21958 19.1006 3.79927 18.291 3.69799 17.4136L2.26519 5.00078H1.00039C0.841261 5.00078 0.688648 4.93757 0.576127 4.82505C0.463605 4.71252 0.400391 4.55991 0.400391 4.40078C0.400391 4.24165 0.463605 4.08904 0.576127 3.97652C0.688648 3.864 0.841261 3.80078 1.00039 3.80078H7.00039ZM4.88959 17.2768C4.9573 17.8617 5.23765 18.4012 5.67729 18.7929C6.11694 19.1845 6.68521 19.4009 7.27399 19.4008H12.7268C13.3156 19.4009 13.8838 19.1845 14.3235 18.7929C14.7631 18.4012 15.0435 17.8617 15.1112 17.2768L16.5272 5.00078H3.47359L4.88959 17.2768ZM8.20039 8.00078C8.35952 8.00078 8.51213 8.06399 8.62466 8.17652C8.73718 8.28904 8.80039 8.44165 8.80039 8.60078V15.8008C8.80039 15.9599 8.73718 16.1125 8.62466 16.225C8.51213 16.3376 8.35952 16.4008 8.20039 16.4008C8.04126 16.4008 7.88865 16.3376 7.77613 16.225C7.6636 16.1125 7.60039 15.9599 7.60039 15.8008V8.60078C7.60039 8.44165 7.6636 8.28904 7.77613 8.17652C7.88865 8.06399 8.04126 8.00078 8.20039 8.00078ZM12.4004 8.60078C12.4004 8.44165 12.3372 8.28904 12.2247 8.17652C12.1121 8.06399 11.9595 8.00078 11.8004 8.00078C11.6413 8.00078 11.4886 8.06399 11.3761 8.17652C11.2636 8.28904 11.2004 8.44165 11.2004 8.60078V15.8008C11.2004 15.9599 11.2636 16.1125 11.3761 16.225C11.4886 16.3376 11.6413 16.4008 11.8004 16.4008C11.9595 16.4008 12.1121 16.3376 12.2247 16.225C12.3372 16.1125 12.4004 15.9599 12.4004 15.8008V8.60078Z"
                          fill="#6D7080"
                        ></path>
                      </svg>
                    </button>
                  )}
              </div>
            </div>
            {sourceAsset?.filename && sourceAsset?.filename.substr(sourceAsset?.filename.lastIndexOf(".") + 1) === "mp4" && (
              <div className="flex justify-end mar-bot14">
                <button
                  className="blue-btn"
                  onClick={() => prepareSubtitleFileUpload(sourceAsset)}
                >
                  Upload Subtitle File (SRT/VTT){" "}
                </button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  </React.Fragment>
  );
}
